export default __webpack_public_path__ + "static/media/Linux.d1d071ec.png";